<template>
  <div class="modal" :class="enforceSignin ? 'is-active' : ''">
    <div class="modal-background"></div>
    <div class="modal-content signin">
      <div class="mb-5">
        <div class="padding-5 border-box rounded-border-box has-background-white">
          <div class="title is-5 has-text-weight-medium">
            <span>Personalize your account</span>
            <span class="is-pulled-right">
              <button class="button is-white" v-on:click="closeSignin">
                <span class="icon has-text-grey">
                  <font-awesome-icon icon="times"></font-awesome-icon>
                </span>
              </button>
            </span>
          </div>
          <p v-if="!user" class="subtitle is-6">Sign In / Sign Up to proceed.</p>
          <p
            v-if="user && !user.firstName"
            class="subtitle is-6"
          >Almost there! Please provide your name.</p>
          <div v-if="!user">
            <div v-if="!verifyToken">
              <div class="field">
                <label class="label has-text-weight-medium">Mobile Number</label>
                <p class="control has-icons-left">
                  <input
                    type="tel"
                    :class="['input', errors.phoneNumber ? 'is-danger' : '']"
                    placeholder="Enter your 10 digit mobile number."
                    v-model="phoneNumber"
                    maxlength="10"
                    v-on:keyup.enter="signIn"
                  />
                  <span class="icon is-small is-left">
                    <font-awesome-icon icon="phone"></font-awesome-icon>
                  </span>
                </p>
                <p class="help is-danger" v-if="errors.phoneNumber">{{errors.phoneNumber.msg}}</p>
              </div>
              <div class="field">
                <p class="control">
                  <button
                    class="button is-primary"
                    :class="[isLoading ? 'is-loading' : '']"
                    @click="signIn"
                  >Sign In / Sign Up</button>
                </p>
              </div>
            </div>
            <div v-if="verifyToken">
              <div class="field">
                <label class="label has-text-weight-medium">OTP</label>
                <p class="control has-icons-left">
                  <input
                    type="number"
                    :class="['input', errors.otp ? 'is-danger' : '']"
                    placeholder="Enter 4 digit OTP you received."
                    v-model="otp"
                    maxlength="4"
                    v-on:keyup.enter="verifyOTP"
                  />
                  <span class="icon is-small is-left">
                    <font-awesome-icon icon="key"></font-awesome-icon>
                  </span>
                </p>
                <p class="help is-danger" v-if="errors.otp">{{errors.otp.msg}}</p>
              </div>
              <div class="field">
                <p class="control">
                  <button
                    class="button is-primary"
                    :class="[isLoading ? 'is-loading' : '']"
                    @click="verifyOTP"
                  >Verify OTP</button>
                </p>
              </div>
            </div>
          </div>
          <div v-if="user && !user.firstName">
            <div class="field">
              <label class="label has-text-weight-medium">First Name</label>
              <p class="control">
                <input
                  type="text"
                  :class="['input', errors.firstName ? 'is-danger' : '']"
                  placeholder="Enter your first name."
                  v-model="firstName"
                  maxlength="100"
                />
              </p>
              <p class="help is-danger" v-if="errors.firstName">{{errors.firstName.msg}}</p>
            </div>
            <div class="field">
              <label class="label has-text-weight-medium">Last Name</label>
              <p class="control">
                <input
                  type="text"
                  :class="['input', errors.lastName ? 'is-danger' : '']"
                  placeholder="Enter your last name."
                  v-model="lastName"
                  maxlength="100"
                  v-on:keyup.enter="updateName"
                />
              </p>
              <p class="help is-danger" v-if="errors.lastName">{{errors.lastName.msg}}</p>
            </div>
            <div class="field">
              <p class="control">
                <button
                  class="button is-primary"
                  :class="[isLoading ? 'is-loading' : '']"
                  @click="updateName"
                >Update</button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Util from "@/util";

export default {
  name: "SignIn",
  props: {},

  data() {
    return {
      errors: {},
      isLoading: false,
      phoneNumber: null,
      firstName: null,
      lastName: null,
      otp: null
    };
  },

  computed: {
    ...mapState("user", ["enforceSignin", "user", "verifyToken"]),
    ...mapGetters("business", ["outletId"])
  },

  methods: {
    reset() {
      this.isLoading = false;
      this.phoneNumber = null;
      this.firstName = null;
      this.lastName = null;
      this.otp = null;
    },

    setError(field, msg = "Unknown error, please try again!") {
      this.errors[field] = {
        msg
      };
    },

    closeSignin() {
      this.reset();
      this.$store.dispatch("user/closeSignin");
    },

    signIn() {
      this.errors = {};

      if (!Util.isValidPhoneNumber(this.phoneNumber)) {
        this.setError("phoneNumber", "Phone number is invalid.");
      }

      if (Object.keys(this.errors).length === 0) {
        this.isLoading = true;
        this.$store
          .dispatch("user/signIn", {
            phoneNumber: `${this.phoneNumber}`.trim(),
            outletId: this.outletId
          })
          .then(() => {
            this.phoneNumber = null;
            this.isLoading = false;
          })
          .catch(error => {
            Util.notify(this, { error });
            this.isLoading = false;
          });
      }
    },

    verifyOTP() {
      this.errors = {};
      if (!this.otp || this.otp.length !== 4 || isNaN(this.otp)) {
        this.setError("otp", "OTP is invalid");
      }

      if (Object.keys(this.errors).length === 0) {
        this.isLoading = true;
        this.$store
          .dispatch("user/verifyOTP", {
            otp: `${this.otp}`.trim(),
            outletId: this.outletId
          })
          .then(() => {
            this.otp = null;
            this.isLoading = false;
          })
          .catch(error => {
            Util.notify(this, { error });
            this.isLoading = false;
          });
      }
    },

    updateName() {
      this.errors = {};
      if (Util.isEmpty(this.firstName)) {
        this.setError("firstName", "First name is required");
      } else if (!Util.isValidName(this.firstName)) {
        this.setError("firstName", "Please enter a valid first name.");
      }

      if (!Util.isEmpty(this.lastName) && !Util.isValidName(this.lastName)) {
        this.setError("lastName", "Please enter a valid last name.");
      }

      if (Object.keys(this.errors).length === 0) {
        this.isLoading = true;
        this.$store
          .dispatch("user/update", {
            firstName: this.firstName.trim(),
            lastName: this.lastName ? this.lastName.trim() : undefined
          })
          .then(() => {
            this.firstName = null;
            this.lastName = null;
            this.isLoading = false;
          })
          .catch(error => {
            Util.notify(this, { error });
            this.isLoading = false;
          });
      }
    }
  }
};
</script>
